import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_EVENT_URL, BASE_URL } from '../apiConfig';

export const fetchManualEventList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EVENT_URL}/manual-event-list`,
    payload,
  );
  return response;
};

export const saveUpdateManualEvent = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EVENT_URL}/manual-event`,
    payload,
  );
  return response;
};

export const deleteManualEvent = async payload => {
  const response = await apiClient.delete(
    `${BASE_URL}${BASE_EVENT_URL}/manual-event`,
    {
      data: payload,
    },
  );
  return response;
};

export const fetchEventDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EVENT_URL}/event-details`,
    payload,
  );
  return response;
};

export const saveUpdateEvent = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EVENT_URL}/event`,
    payload,
  );
  return response;
};

export const deleteEvent = async payload => {
  const response = await apiClient.delete(
    `${BASE_URL}${BASE_EVENT_URL}/event`,
    {
      data: payload,
    },
  );
  return response;
};

export const fetchManualEventById = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EVENT_URL}/manual-event-by-id`,
    payload,
  );
  return response;
};
